var dependencies = [
  'ui.router',
  'ui.bootstrap',
  'ngAnimate',
  'angularMoment',
  'pascalprecht.translate',
  'restangular',
  'angular-carousel'
];

angular
  .module('app', dependencies)
  .config(function (RestangularProvider, ENV) {
    RestangularProvider.setBaseUrl(ENV.api);
  })
  // eslint-disable-next-line
  .run(function ($rootScope, $transitions, $translate, $injector, $log) {

    $transitions.onStart({}, function (transition) {
      if (transition.entering()[0].abstract === true) {
        $rootScope.$emit('startLoading', {
          title: $translate.isReady() ? $translate.instant('loader.PLEASE_WAIT') : 'Please wait',
          description: $translate.isReady() ? $translate.instant('loader.SETTINGS') : 'Loading settings'
        });
      }
    });
    $transitions.onSuccess({}, function (transition) {
      if (transition.entering()[0].abstract === true) {
        $rootScope.$emit('stopLoading');
      }
    });
  });
